import { IApplicationState } from '../../types/redux';

export function selectBrokerSelfRequestFormWidgetLoading(state: IApplicationState) {
  return state.brokerSelfRequestFormWidget.loading;
}
